import React from 'react';

type SubscriptionContextValues = {
    organization: string | undefined;
    isLoaded: boolean;
};

const SubscriptionContext = React.createContext<SubscriptionContextValues>({
    organization: undefined,
    isLoaded: false,
});

export default SubscriptionContext;
